import { render, staticRenderFns } from "./PlaylistForm.vue?vue&type=template&id=2be34b84&scoped=true"
import script from "./PlaylistForm.vue?vue&type=script&lang=js"
export * from "./PlaylistForm.vue?vue&type=script&lang=js"
import style0 from "./PlaylistForm.vue?vue&type=style&index=0&id=2be34b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be34b84",
  null
  
)

export default component.exports